import { useMemo } from 'react';

import { useCurrentUser } from '@qualio/ui-components';
import { useQuery } from 'react-query';
import { User } from 'types';

import supplierApi from '../api/supplier.api';
import { UserOptionsType } from './useCompanyUsers';

type UseSponsorsQueryResult = {
  companyUsers?: User[];
  usersOptions: UserOptionsType[];
  isCompanyUsersLoading: boolean;
  companyUsersError: any;
};

export const useSponsors = (): UseSponsorsQueryResult => {
  const { companyId } = useCurrentUser();

  const {
    data: companyUsers,
    isLoading: isCompanyUsersLoading,
    error: companyUsersError,
  } = useQuery(`getCompanySponsors-${companyId}`, () => supplierApi.listUsers(companyId, false));

  const usersOptions = useMemo(() => {
    return (companyUsers ?? []).map((user) => ({
      ...user,
      label: `${user.fullName || ''} (${user.email})`,
      value: '' + user.id || '',
    }));
  }, [companyUsers]);

  return {
    companyUsers,
    isCompanyUsersLoading,
    companyUsersError,
    usersOptions,
  };
};
